import {schema} from 'normalizr';

import schemaPages from "../page/schema";

export default new schema.Entity('blocks', {
  pages: [schemaPages],
});